import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Checkbox, Form, Input, Modal } from 'antd';
import * as Hangul from 'hangul-js';
import React, { Component } from 'react';
import { withAlert } from 'react-alert';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import { bindActionCreators } from 'redux';
import {
  addBlindAsync,
  calcDistanceAsync,
  calcShippingDataAsync,
  createOrderAsync,
} from '../../api/api';
import AddressModal from '../../components/modal/AddressModal';
import KeyInputModal from '../../components/modal/KeyInputModal';
import MapModal from '../../components/modal/MapModal';
import PaymentDialog from '../../components/modal/PaymentDialog';
import PhoneInputModal from '../../components/modal/PhoneInputModal';
import PriceInputModal from '../../components/modal/PriceInputModal';
import Const from '../../const';
import '../../css/modal.scss';
import {
  defaultConst,
  packAmountCodeString,
  paymentMethodCode,
  paymentMethodString,
  pickupTimeCode,
  pickupTimeValue,
  modalStyle, modalErrorStyle,
} from '../../lib/util/codeUtil';
import {
  calcPriceOfOrderPayments,
  checkOverPrice,
  comma,
  formatKm,
} from '../../lib/util/numberUtil';
import BlindMsgInputModal from './BlindMsgInputModal';
import { getUseNotifyOrderEtc } from '../../lib/module';
import image from '../../res/image';

const regExpPhone =
  /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/;

const FormItem = Form.Item;

const getPaymentMethod = (payments) => {
  if (typeof payments === 'undefined' || payments.length <= 0) return 0;
  return payments.length > 1 ? 4 : payments[0].paymentMethod;
};

class UpdateReregistModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      blindMsgInputModalOpen: false,
      riderIsBlocked: false,

      isEditMode: true,
      custPhone: '',
      destAddr1: '',
      destAddr2: '',
      destAddr3: '',
      packAmount: 1,
      dist: '',
      deliveryBasicPrice: 0,
      deliveryAddPrice: 0,

      addrModalOpen: false,
      mapModalOpen: false,
      phoneInputModalOpen: false,
      priceInputModalOpen: false,
      keyInputModalOpen: false,
      keyInputModal2Open: false,

      paymentType: 3,
      orderPayments: [],
      paymentMethod: defaultConst.paymentMethod,
      pickupTime: defaultConst.pickupTime,
      itemPrepared: false,

      frLat: 0.0,
      frLng: 0.0,
      targetLat: 0,
      targetLng: 0,

      deliveryData: 0,

      overPriceSetting: 100000,
      overPrice: false,
    };
    this.formRef = React.createRef();
  }

  componentDidMount() {
    const { data } = this.props;

    if (data) {
      calcDistanceAsync(data.latitude, data.longitude).then((shippingData) => {
        if (!shippingData) {
          Modal.error({
            title: '배달비 정보 조회 오류',
            content: <div>오류가 발생하였습니다. 다시 시도해 주십시오.</div>,
            ...modalErrorStyle,
          });
        } else {
          this.setState({
            frLat: shippingData.lat,
            frLng: shippingData.lng,
            targetLat: shippingData.lat,
            targetLng: shippingData.lng,
            dist: shippingData.dist,
            deliveryBasicPrice: shippingData.deliveryBasicPrice,
            deliveryAddPrice: this.props.data
              ? this.props.data.extraDeliveryPrice
              : shippingData.deliveryAddPrice,
          });
        }
      });

      this.formRef.current.setFieldsValue({
        custMessage: data.custMessage,
        custPhone: data.custPhone,
        destAddr1: data.destAddr1,
        destAddr2: data.destAddr2,
        destAddr3: data.destAddr3,
        orderPrice: comma(data.orderPrice),
        packAmount: data.packAmount,
        orderPayments: data.orderPayments,
        paymentMethod: getPaymentMethod(data.orderPayments),
        pickupTime: data.arriveReqTime,
      });

      this.setState({
        custPhone: data.custPhone,
        destAddr1: data.destAddr1,
        destAddr2: data.destAddr2,
        destAddr3: data.destAddr3,
        orderPrice: data.orderPrice,
        packAmount: data.packAmount,
        orderPayments: data.orderPayments,
        paymentMethod: getPaymentMethod(data.orderPayments),
        pickupTime: data.arriveReqTime,
      });
    }
    this.updateDeliveryData();
    this.pollingDeliveryData = setInterval(() => {
      this.updateDeliveryData();
    }, 5000);
  }

  componentWillUnmount() {
    clearInterval(this.pollingDeliveryData);
    // clearInterval(this.pollingAddrBranchData);
  }

  openAddrModal = () => {
    this.setState({ addrModalOpen: true });
  };
  closeAddrModal = () => {
    this.setState({ addrModalOpen: false });
  };
  openMapModal = () => {
    this.setState({
      destAddr1: this.formRef.current.getFieldValue('destAddr1'),
      destAddr2: this.formRef.current.getFieldValue('destAddr2'),
      mapModalOpen: true,
    });
  };
  closeMapModal = () => {
    this.setState({ mapModalOpen: false });
  };
  openPaymentModal = () => {
    this.setState({ paymentOpen: true });
  };
  closePaymentModal = () => {
    this.setState({ paymentOpen: false });
  };
  openPhoneInputModal = () => {
    this.setState({ phoneInputModalOpen: true });
  };
  closePhoneInputModal = () => {
    this.setState({ phoneInputModalOpen: false });
  };
  openPriceInputModal = () => {
    this.setState({ priceInputModalOpen: true });
  };
  closePriceInputModal = () => {
    this.setState({ priceInputModalOpen: false });
  };
  openKeyInputModal = () => {
    this.setState({ keyInputModalOpen: true });
  };
  closeKeyInputModal = () => {
    this.setState({ keyInputModalOpen: false });
  };
  openKeyInputModal2 = () => {
    this.setState({ keyInputModal2Open: true });
  };
  closeKeyInputModal2 = () => {
    this.setState({ keyInputModal2Open: false });
  };
  setAddress = (address) => {
    this.formRef.current.setFieldsValue({ destAddr1: address.roadAddr });
    this.setState({
      destAddr3: address.jibunAddr,
      addrModalOpen: false,
    });

    calcShippingDataAsync(address.roadAddr, address.jibunAddr).then((data) => {
      if (data !== null) {
        this.setState({
          targetLat: data.lat,
          targetLng: data.lng,
          dist: data.dist,
          deliveryBasicPrice: data.deliveryBasicPrice,
          deliveryAddPrice: this.props.data
            ? this.props.data.extraDeliveryPrice
            : data.deliveryAddPrice,
        });
      }
    });
  };
  onClose = () => {
    this.setState({
      blindMsgInputModalOpen: false,
      isEditMode: false,
    });
    this.props.close();
  };
  onHandle = () => {
    if (!this.state.isEditMode) {
      this.setState({ isEditMode: true });
    } else {
      this.setState({ isEditMode: false });
    }
  };
  onUpdateOverPrice = () => {
    const overPrice = checkOverPrice(
      this.formRef.current.getFieldValue('orderPrice'),
      this.state.overPrice,
      this.state.overPriceSetting
    );

    this.setState({ overPrice });
  };
  onCheckAndUpdatePaymentMethod = (paymentMethod) => {
    const cardPay = this.state.orderPayments.find(
      (x) => x.paymentMethod == paymentMethodCode.card && x.paymentAmount > 0
    );
    if (cardPay && cardPay.paymentStatus === 2) {
      Modal.error({
        title: '결제 변경',
        content: (
          <div>
            카드결제 완료건이 있습니다. 카드결제 금액을 변경하는 경우 승인취소
            후 다시 결제해야 합니다.
          </div>
        ),
        ...modalErrorStyle,
      });
      return;
    }

    if (
      this.state.paymentMethod === paymentMethodCode.installment &&
      this.state.orderPayments.length > 1 &&
      paymentMethod !== paymentMethodCode.installment
    ) {
      const self = this;
      Modal.confirm({
        ...modalStyle,
        content: '분할 결제정보가 초기화 됩니다. 결제수단을 변경 하시겠습니까?',
        okText: '확인',
        cancelText: '취소',
        onOk() {
          self.setState({
            paymentMethod,
            orderPayments: [],
          });
        },
        onCancel() {},
      });
    } else {
      this.setState({ paymentMethod });
      if (paymentMethod === paymentMethodCode.installment) {
        this.openPaymentModal();
      }
    }
  };
  handlePaymentChange = (data) => {
    let orderPrice = 0;
    let result = 'SUCCESS';
    do {
      if (
        typeof data === 'undefined' ||
        !Array.isArray(data) ||
        data.length < 1
      ) {
        result = 'INVALID_TYPE';
        break;
      }
      for (let i = 0; i < data.length; ++i) {
        if (data[i].paymentAmount === 0) {
          result = 'INVALID_PRICE';
          break;
        }
      }
      if (result !== 'SUCCESS') break;
      orderPrice = calcPriceOfOrderPayments(data);
      if (orderPrice <= 0) {
        result = 'INVALID_PRICE';
        break;
      }
    } while (false);

    // early return
    if (result !== 'SUCCESS') {
      Modal.error({
        title: '분할결제 오류',
        content: (
          <div>분할결제 정보가 올바르지 않습니다. 다시 시도해 주십시오.</div>
        ),
        ...modalErrorStyle,
      });
      return;
    }

    if (data.length === 1) {
      const self = this;
      const paymentMethod = data[0].paymentMethod;
      Modal.info({
        title: '분할결제 알림',
        content: (
          <div>
            {comma(orderPrice)}원 '{paymentMethodString[paymentMethod]}'결제 한
            건이 등록되어 결제수단이 '{paymentMethodString[paymentMethod]}
            '결제로 전환됩니다.
          </div>
        ),
        ...modalStyle,
        onOk() {
          self.setState({ paymentMethod });
          self.setState({ orderPayments: [] });
        },
      });
    } else {
      this.setState({ orderPayments: data });
    }

    this.formRef.current.setFieldsValue({ orderPrice: comma(orderPrice) });
  };
  updateDeliveryData = () => {
    this.setState(
      {
        deliveryData: reactLocalStorage.getObject(
          Const.appName + '#deliverydata'
        ),
        frBasicPickupTime: reactLocalStorage.getObject(
          Const.appName + '#basicPickupTime'
        ),
      },
      () => {
        this.initializePickupTime();
      }
    );
  };
  handleSubmit = async () => {
    const self = this;
    const form = this.formRef.current;
    const orderPrice = parseInt(
      (form.getFieldValue('orderPrice') + '').replace(/,/g, '')
    );

    // if (orderPrice === 0) {
    //     Modal.error({
    //         title: "접수요청 오류",
    //         content: (
    //             <div>
    //                 주문금액이 올바르지 않습니다. 다시 시도해 주십시오.
    //             </div>
    //         )
    //     });
    //     return;
    // }
    if (
      this.state.paymentMethod === paymentMethodCode.installment &&
      orderPrice !== calcPriceOfOrderPayments(this.state.orderPayments)
    ) {
      Modal.error({
        title: '접수요청 오류',
        content: (
          <div>분할결제 정보가 올바르지 않습니다. 다시 시도해 주십시오.</div>
        ),
        ...modalErrorStyle,
      });
      return;
    }
    if (form.getFieldValue('custPhone') == '') {
      Modal.error({
        title: '전화번호 오류',
        content: (
          <div>
            유효하지 않는 전화번호입니다. 전화번호를 올바르게 입력해주세요.
          </div>
        ),
        ...modalErrorStyle,
      });
      return;
    }

    if (pickupTimeValue.indexOf(this.state.pickupTime) === -1) {
      Modal.error({
        title: '요청시간 오류',
        content: <div>가능한 픽업요청시간을 선택해주세요.</div>,
        ...modalErrorStyle,
      });
      return;
    }

    const orderPayments =
      this.state.paymentMethod === paymentMethodCode.installment
        ? this.state.orderPayments
        : [
            {
              paymentMethod: this.state.paymentMethod,
              paymentAmount: orderPrice,
              paymentStatus: 1,
            },
          ];

    const { data } = this.props;
    const useEtcVoiceGuidance = getUseNotifyOrderEtc();

    Modal.confirm({
      ...modalStyle,
      content: '배달정보를 접수하시겠습니까?',
      okText: '확인',
      cancelText: '취소',
      onOk() {
        const custPhone = form.getFieldValue('custPhone').replace(/-/g, '');
        const destAddr1 = form.getFieldValue('destAddr1');
        const destAddr2 = form.getFieldValue('destAddr2');
        const custMessage = form.getFieldValue('custMessage');
        const newOrder = {
          ...data,
          latitude: self.state.targetLat,
          longitude: self.state.targetLng,
          orderPayments: orderPayments,
          destAddr1,
          destAddr2,
          destAddr3: self.state.destAddr3,
          custMessage,
          custPhone,
          orderPrice,
          packAmount: self.state.packAmount,
          distance: self.state.dist,
          basicDeliveryPrice: self.state.deliveryBasicPrice,
          extraDeliveryPrice: self.state.deliveryAddPrice,
          deliveryPrice:
            self.state.deliveryBasicPrice + self.state.deliveryAddPrice,
          arriveReqTime: self.state.pickupTime,
          // ...form.getFieldValue(["destAddr1", "destAddr2","custMessage"]),
          orderDate: '',
          itemPrepared: self.state.itemPrepared,
          userIdx: null,
        };

        createOrderAsync(newOrder).then((result) => {
          if (result === 'SUCCESS') {
            /*if (self.state.deliveryData.delayPickupTime === 0) {
              const pickupTimeIndex = pickupTimeValue.indexOf(
                self.state.pickupTime
              );
              if (pickupTimeIndex !== -1) {
                reactLocalStorage.setObject(
                  Const.appName + '#refPickupTime',
                  pickupTimeIndex
                );
              }
            }*/
            self.props.alert.show('배달정보를 접수하였습니다.');
            self.onClose();
          } else if (result === 'DELIVERY_NOT_ENABLED') {
            return;
          } else {
            if (
              result === 'NOT_ENOUGH_NCASH' ||
              result === 'NCASH_AUTO_CHARGE_FAIL'
            ) {
              self.props.alert.show(
                '예치금이 얼마 남지 않았습니다. 예치금을 충전해 주세요.'
              );
              if (useEtcVoiceGuidance) {
                let audio = new Audio('11.wav');
                audio.volume = this.props.posReducer.volume;
                audio.crossOrigin = 'anonymous';
                audio.play();
              }
            }
            Modal.error({
              title: '배달정보 재접수',
              content: (
                <div>
                  시스템에러로 배달요청에 실패하였습니다. 잠시 후 다시
                  시도해주세요.
                </div>
              ),
              ...modalErrorStyle,
              onOk() {},
            });
          }
        });
      },
      onCancel() {},
    });
  };
  // isEnablePickupTime = (id) => {
  //   if (typeof id !== "number") {
  //     return false;
  //   }
  //   if (this.state.deliveryData && !this.state.deliveryData.deliveryEnabled) {
  //     return false;
  //   }
  //   if (this.state.deliveryData && this.state.deliveryData.pickupTimeMap) {
  //     const flag = this.state.deliveryData.pickupTimeMap[id];
  //     return typeof flag === "undefined" ? false : flag;
  //   }
  //   return true;
  // };
  initializePickupTime = () => {
    const { data } = this.props;
    const fastestDelayTime =
      this.state.deliveryData.delayPickupTime + this.state.frBasicPickupTime;
    if (!this.state.initializePickupTimeCnt) {
      if (this.state.deliveryData.delayPickupTime) {
        if (fastestDelayTime > data.arriveReqTime) {
          const enablePickupTimes = pickupTimeValue.filter(
            (x) => x >= fastestDelayTime
          );

          const pickupTimeIdx = pickupTimeValue[fastestDelayTime];
          if (pickupTimeIdx !== -1) {
            this.setState({
              pickupTime: fastestDelayTime,
              initializePickupTimeCnt: true,
            });
          } else {
            this.setState({
              initializePickupTimeCnt: true,
            });
          }

          return;
        } else {
          this.setState({
            pickupTime: data.arriveReqTime,
            initializePickupTimeCnt: true,
          });
          return;
        }
      }
    }
  };

  render() {
    const { data } = this.props;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 17 },
      },
    };

    const skinType = Const.skinType.toUpperCase();

    return (
      <React.Fragment>
        <Form
          ref={this.formRef}
          {...formItemLayout}
          onFinish={this.handleSubmit}>
          <div
            className="Modal-detail-overlay"
            onClick={() => this.onClose()}
          />

          <div className="Modal-detail" style={{ textAlign: 'left' }}>
            <BlindMsgInputModal
              isOpen={this.state.blindMsgInputModalOpen}
              close={() => this.onClose()}
              keyin={(msg) => {
                addBlindAsync(data.userIdx, msg, () => {
                  this.setState({
                    riderIsBlocked: true,
                    blindMsgInputModalOpen: false,
                  });
                });
              }}
              ok={() => {
                this.setState({ blindMsgInputModalOpen: false });
              }}
            />

            {/* 타이틀 */}

            <div className="detail-title">
              <div>수정접수</div>
              <div onClick={() => this.onClose()}>
                {' '}
                <img
                  style={{ display: 'inline' }}
                  src={image.closeIcon}
                  alt=""
                />{' '}
              </div>
            </div>

            {/* 컨텐츠 */}

            <div className="detail-content">
              <div className="detail-content-box">
                <div className="detail-edit-num mobile">
                  <div> 전화번호 :</div>

                  <div className="detail-edit-content-box mobile">
                    <FormItem
                      name="custPhone"
                      value={this.state.custPhone}
                      rules={[
                        {
                          required: true,
                          message: '고객 전화번호를 입력해주세요',
                        },
                      ]}>
                      <Input
                        id="input-02"
                        placeholder={'고객 전화번호를 - 없이 입력해 주세요'}
                        onFocus={this.openPhoneInputModal}
                        autoComplete="off"
                      />
                    </FormItem>
                    <div className="deliveryDetailKeypad-phone">
                      <PhoneInputModal
                        isOpen={this.state.phoneInputModalOpen}
                        close={this.closePhoneInputModal}
                        keyin={(data) => {
                          const str =
                            this.formRef.current.getFieldValue('custPhone');
                          this.formRef.current.setFieldsValue({
                            custPhone: str ? str + data + '' : data + '',
                          });
                        }}
                        backspace={() => {
                          const str =
                            this.formRef.current.getFieldValue('custPhone');
                          this.formRef.current.setFieldsValue({
                            custPhone: str ? str.substr(0, str.length - 1) : '',
                          });
                        }}
                        reset={() => {
                          this.formRef.current.setFieldsValue({
                            custPhone: '',
                          });
                        }}
                        ok={() => {
                          const value =
                            this.formRef.current.getFieldValue('custPhone');
                          if (value == '') {
                            Modal.error({
                              title: '전화번호 오류',
                              content: (
                                <div>
                                  유효하지 않는 전화번호입니다. 전화번호를
                                  올바르게 입력해주세요.
                                </div>
                              ),
                              ...modalErrorStyle,
                            });
                          } else {
                            this.setState({ phoneInputModalOpen: false });
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div>
                  <div className="modal-01">
                      <AddressModal
                        isOpen={this.state.addrModalOpen}
                        setAddress={this.setAddress}
                        close={this.closeAddrModal}
                      />
                  </div>

                  {/* 고객 주소 입력 */}

                  <div className="detail-bg2 addr edit">
                    <div>
                      <span>*</span> 고객주소 :
                    </div>

                    <div className="detail-edit-content-box">
                      <div>
                        <div>
                          <FormItem
                            name="destAddr1"
                            value={this.state.destAddr1}
                            // initialValue={data.destAddr1}
                            rules={[
                              {
                                required: true,
                                message: '고객 주소를 입력해주세요',
                              },
                            ]}>
                            <Input
                              id="input-01"
                              placeholder={'고객 주소를 입력해 주세요'}
                              disabled
                              style={{ marginBottom: 10 }}
                            />
                          </FormItem>
                        </div>

                        <div
                          className="detail-edit-btn"
                          onClick={this.openAddrModal}>
                          <img
                            style={{ display: 'inline' }}
                            src={image.SearchIcon}
                            alt=""
                          />
                        </div>
                      </div>

                      <div>
                        <div>
                          <FormItem
                            name="destAddr2"
                            value={this.state.destAddr2}
                            // initialValue={data.destAddr2}
                            // rules={[
                            //   {
                            //     required: true,
                            //     message: "상세 주소를 입력해주세요",
                            //   },
                            // ]}
                          >
                            <Input
                              id="input-01"
                              placeholder={'상세 주소를 입력해 주세요'}
                              onFocus={this.openKeyInputModal}
                              autoComplete="off"
                            />
                          </FormItem>
                        </div>
                        <div className="modal-02" style={{}}>
                          <KeyInputModal
                            isOpen={this.state.keyInputModalOpen}
                            close={this.closeKeyInputModal}
                            keyin={(data) => {
                              const str =
                                this.formRef.current.getFieldValue('destAddr2');
                              // console.log(str);
                              this.formRef.current.setFieldsValue({
                                destAddr2: str
                                  ? Hangul.assemble([
                                      ...Hangul.disassemble(str),
                                      data,
                                    ])
                                  : data + '',
                              });
                            }}
                            backspace={() => {
                              const str =
                                this.formRef.current.getFieldValue('destAddr2');
                              // console.log(str);
                              this.formRef.current.setFieldsValue({
                                destAddr2: str
                                  ? str.substr(0, str.length - 1)
                                  : '',
                              });
                            }}
                            ok={() => {
                              this.setState({ keyInputModalOpen: false });
                            }}
                            style={{ float: 'left' }}
                          />
                        </div>
                        <div
                          className="detail-edit-btn"
                          onClick={() => {
                            if (
                              this.state.frLat === 0 ||
                              this.state.frLng === 0 ||
                              this.state.targetLat === 0 ||
                              this.state.targetLng === 0
                            ) {
                              this.props.alert.show(
                                '위치정보를 찾을 수 없습니다.'
                              );
                              return;
                            }
                            this.openMapModal();
                          }}>
                          <img
                            style={{ display: 'inline' }}
                            src={image.MapIcon}
                            alt=""
                          />
                        </div>
                        <MapModal
                          isOpen={this.state.mapModalOpen}
                          close={this.closeMapModal}
                          frLat={this.state.frLat}
                          frLng={this.state.frLng}
                          targetLat={this.state.targetLat}
                          targetLng={this.state.targetLng}
                          dist={this.state.dist}
                          deliveryBasicPrice={this.state.deliveryBasicPrice}
                          deliveryAddPrice={this.state.deliveryAddPrice}
                          destAddr1={this.state.destAddr1}
                          destAddr2={this.state.destAddr2}
                          destAddr3={this.state.destAddr3}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* 전화번호 */}

                <div className="detail-edit-num mobileoff">
                  <div style={{ paddingLeft: 20 }}> 전화번호 :</div>

                  <div className="detail-edit-content-box mobileoff">
                    <FormItem
                      name="custPhone"
                      value={this.state.custPhone}
                      // initialValue={data.custPhone}
                      rules={[
                        {
                          required: true,
                          message: '고객 전화번호를 입력해주세요',
                        },
                      ]}>
                      <Input
                        id="input-02"
                        placeholder={'고객 전화번호를 - 없이 입력해 주세요'}
                        onFocus={this.openPhoneInputModal}
                        autoComplete="off"
                      />
                    </FormItem>
                    <div className="updateReregistKeypad-phone">
                      <PhoneInputModal
                        isOpen={this.state.phoneInputModalOpen}
                        close={this.closePhoneInputModal}
                        keyin={(data) => {
                          const str =
                            this.formRef.current.getFieldValue('custPhone');
                          // console.log(str);
                          this.formRef.current.setFieldsValue({
                            custPhone: str ? str + data + '' : data + '',
                          });
                        }}
                        backspace={() => {
                          const str =
                            this.formRef.current.getFieldValue('custPhone');
                          // console.log(str);
                          this.formRef.current.setFieldsValue({
                            custPhone: str ? str.substr(0, str.length - 1) : '',
                          });
                        }}
                        reset={() => {
                          this.formRef.current.setFieldsValue({
                            custPhone: '',
                          });
                        }}
                        ok={() => {
                          const value =
                            this.formRef.current.getFieldValue('custPhone');
                          if (value == '') {
                            Modal.error({
                              title: '전화번호 오류',
                              content: (
                                <div>
                                  유효하지 않는 전화번호입니다. 전화번호를
                                  올바르게 입력해주세요.
                                </div>
                              ),
                              ...modalErrorStyle,
                            });
                          } else {
                            this.setState({ phoneInputModalOpen: false });
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="mobileoff customerMessage">
                  <div
                    style={{
                      display: 'inline-block',
                      verticalAlign: 'middle',
                    }}>
                    {' '}
                    고객요청사항 :{' '}
                  </div>
                  <div className="detail-edit-content-box mobileoff">
                    <div>
                      <FormItem
                        name="custMessage"
                        value={this.state.custMessage}
                        // initialValue={data.custMessage}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: "배송메세지를 입력해주세요",
                        //   },
                        // ]}
                      >
                        <Input
                          id="input-02"
                          placeholder={'배송메세지를 입력해 주세요'}
                          onFocus={this.openKeyInputModal2}
                          autoComplete="off"
                        />
                      </FormItem>
                    </div>
                    <div className="updateReregistKeypad-message" style={{}}>
                      <KeyInputModal
                        isOpen={this.state.keyInputModal2Open}
                        close={this.closeKeyInputModal2}
                        keyin={(data) => {
                          const str =
                            this.formRef.current.getFieldValue('custMessage');
                          // console.log(str);
                          this.formRef.current.setFieldsValue({
                            destAddr2: str
                              ? Hangul.assemble([
                                  ...Hangul.disassemble(str),
                                  data,
                                ])
                              : data + '',
                          });
                        }}
                        backspace={() => {
                          const str =
                            this.formRef.current.getFieldValue('custMessage');
                          // console.log(str);
                          this.formRef.current.setFieldsValue({
                            destAddr2: str ? str.substr(0, str.length - 1) : '',
                          });
                        }}
                        ok={() => {
                          this.setState({ keyInputModal2Open: false });
                        }}
                        style={{ float: 'left' }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="detail-content-box">
                <div className="detail-pickup-time">
                  <div>픽업요청시간 :</div>
                  <div className="pickup-element-block6-title-btn">
                    {pickupTimeCode.map((row, index) => {
                      if (index === 0) return null;
                      return pickupTimeValue[index] >=
                        this.state.deliveryData.delayPickupTime +
                          this.state.frBasicPickupTime ? (
                        <div
                          key={index}
                          className={this.state.pickupTime === pickupTimeValue[index] && skinType === "GOGOIT"
                              ? 'gogoit-pickup-element-block6-title-btn-menu active'
                              : skinType === "GOGOIT"
                                  ? 'gogoit-pickup-element-block6-title-btn-menu'
                                  : this.state.pickupTime === pickupTimeValue[index]
                                      ? 'pickup-element-block6-title-btn-menu active'
                                      : 'pickup-element-block6-title-btn-menu'
                          }
                          onClick={() =>
                            this.setState({
                              pickupTime: pickupTimeValue[index],
                            })
                          }>
                          {row}
                        </div>
                      ) : (
                        <div
                          key={index}
                          className={
                            'pickup-element-block6-title-btn-menu disable'
                          }>
                          {row}
                        </div>
                      );
                    })}
                  </div>
                  <div className="pickup-element-right">
                    <Checkbox
                      // style={{ paddingLeft: 5.7 }}
                      onChange={(e) => {
                        this.setState({ itemPrepared: e.target.checked });
                      }}
                      checked={this.state.itemPrepared}>
                      조리완료
                    </Checkbox>
                  </div>
                </div>

                {/* 배송비 정보 입력 */}

                <div className="detail-bg2 edit price-edit">
                  <div className="mobileoff">
                    <span>*</span> 배송비 정보 : <br />( VAT 별도 )
                  </div>

                  <div className="price-edit-order mobile">
                    <div>
                      <span>*</span> 배송비 정보 : <br />( VAT 별도 )
                    </div>
                    <div>
                      주문금액
                      <div>
                        <FormItem
                          name="orderPrice"
                          value={this.state.orderPrice}
                          rules={[
                            {
                              required: true,
                              message: '주문금액을 입력해주세요',
                            },
                          ]}>
                          <Input
                            id="input-02"
                            placeholder={'주문금액을 입력해 주세요'}
                            onFocus={this.openPriceInputModal}
                            autoComplete="off"
                            onChange={() => this.onUpdateOverPrice}
                          />
                        </FormItem>
                        <span>원</span>
                      </div>
                    </div>
                  </div>

                  <div className={skinType === "GOGOIT" ? "gogoit-price-edit-box" : "price-edit-box"}>
                    <ul>
                      <li className="mobileoff">
                        <p> 주문금액 </p>
                        <div>
                          <FormItem
                            name="orderPrice"
                            value={this.state.orderPrice}
                            // initialValue={data.orderPrice}
                            rules={[
                              {
                                required: true,
                                message: '주문금액을 입력해주세요',
                              },
                            ]}>
                            <Input
                              id="input-02"
                              placeholder={'주문금액을 입력해 주세요'}
                              onFocus={this.openPriceInputModal}
                              autoComplete="off"
                              onChange={() => this.onUpdateOverPrice}
                            />
                          </FormItem>
                          <span>원</span>
                        </div>
                      </li>
                      <div className="updateReregistKeypad-price mobileoff">
                        <PriceInputModal
                          isOpen={this.state.priceInputModalOpen}
                          close={this.closePriceInputModal}
                          keyadd={(data) => {
                            let str = (
                              this.formRef.current.getFieldValue('orderPrice') +
                              ''
                            ).replace(/,/g, '');
                            let value = 0;
                            if (str && !isNaN(str)) value = parseInt(str);

                            // console.log(value);
                            this.formRef.current.setFieldsValue({
                              orderPrice: comma(value + data),
                            });
                            this.onUpdateOverPrice();
                          }}
                          keyin={(data) => {
                            let str = (
                              this.formRef.current.getFieldValue('orderPrice') +
                              ''
                            ).replace(/,/g, '');
                            let value = 0;
                            if (str && !isNaN(str)) {
                              value = parseInt(str);
                            }
                            this.formRef.current.setFieldsValue({
                              orderPrice: comma(parseInt(value + '' + data)),
                            });
                            this.onUpdateOverPrice();
                          }}
                          backspace={() => {
                            let str = (
                              this.formRef.current.getFieldValue('orderPrice') +
                              ''
                            ).replace(/,/g, '');
                            let value = 0;
                            if (str && !isNaN(str)) value = parseInt(str);

                            // console.log(value);
                            this.formRef.current.setFieldsValue({
                              orderPrice: comma(parseInt(value / 10)),
                            });
                            this.onUpdateOverPrice();
                          }}
                          reset={() => {
                            this.formRef.current.setFieldsValue({
                              orderPrice: '',
                            });
                            this.onUpdateOverPrice();
                          }}
                          ok={() => {
                            this.setState({ priceInputModalOpen: false });
                          }}
                        />
                      </div>

                      {/* <li>
                        {" "}
                        <p> 할증 금액 </p> {comma(this.state.deliveryAddPrice)}{" "}
                        원{" "}
                      </li>
                      <li>
                        {" "}
                        <p> 배송비 </p> {comma(this.state.deliveryBasicPrice)}{" "}
                        원{" "}
                      </li> */}
                      <li>
                        {' '}
                        <p> 총 배송비 </p>{' '}
                        {comma(
                          this.state.deliveryBasicPrice +
                            this.state.deliveryAddPrice
                        )}{' '}
                        원{' '}
                      </li>
                    </ul>
                  </div>

                  <div>
                    <ul>
                      <li>
                        {' '}
                        <p> 거리 </p> {formatKm(this.state.dist)}
                      </li>
                      <li>
                        {' '}
                        <p> 수량 </p>
                        <div
                          className="amount-box"
                          onClick={() => {
                            this.setState({
                              selectOpen: !this.state.selectOpen,
                            });
                          }}>
                          <div
                            className={this.state.selectOpen && skinType === "GOGOIT" ?
                                'gogoit-amount-box-on'
                                :
                              this.state.selectOpen
                                ? 'amount-box-on'
                                : 'amount-box-off'
                            }>
                            묶음 ({this.state.packAmount}개)
                            <img
                              style={{ display: 'inline' }}
                              src={
                                this.state.selectOpen
                                  ? image.SelectIcon
                                  : image.UnselectIcon
                              }
                              alt=""
                            />
                          </div>

                          {this.state.selectOpen && (
                            <div className="amount-box-row">
                              {Object.entries(packAmountCodeString).map(
                                ([key, value]) => (
                                  <div>
                                    <div
                                      className={this.state.packAmount === parseInt(key) && skinType === "GOGOIT"
                                          ? 'gogoit-amount-box-row-on'
                                          : this.state.packAmount === parseInt(key)
                                              ? 'amount-box-row-on'
                                              : 'amount-box-row-off'
                                      }
                                      onClick={() => {
                                        this.setState({
                                          packAmount: parseInt(key),
                                        });
                                      }}>
                                      {value}
                                    </div>
                                  </div>
                                )
                              )}
                            </div>
                          )}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>

                <div>
                  결제수단 :
                  <p>
                    {data.orderPayments
                      ? data.orderPayments.length === 0
                        ? ''
                        : data.orderPayments.length > 1
                        ? '분할'
                        : paymentMethodString[
                            data.orderPayments[0].paymentMethod
                          ]
                      : ''}
                  </p>
                  {this.state.paymentOpen && (
                    <PaymentDialog
                      close={this.closePaymentModal}
                      orderPayments={this.state.orderPayments}
                      handlePaymentChange={this.handlePaymentChange}
                      editable={true}
                      orderPrice={
                        typeof this.formRef.current.getFieldValue(
                          'orderPrice'
                        ) === 'undefined'
                          ? 0
                          : parseInt(
                              (
                                this.formRef.current.getFieldValue(
                                  'orderPrice'
                                ) + ''
                              ).replace(/,/g, '')
                            )
                      }
                    />
                  )}
                  <div className={skinType === "GOGOIT" ? "gogoit-detail-payment-type" : "detail-payment-type"}>
                    <ul>
                      <li
                        key={3}
                        className={
                          'payment-btn' +
                          (paymentMethodCode.advance ===
                          this.state.paymentMethod
                            ? ' active'
                            : '')
                        }
                        onClick={() =>
                          this.onCheckAndUpdatePaymentMethod(
                            paymentMethodCode.advance
                          )
                        }>
                        {paymentMethodString[paymentMethodCode.advance]}
                      </li>
                      <li
                        key={4}
                        className={
                          'payment-btn' +
                          (paymentMethodCode.installment ===
                          this.state.paymentMethod
                            ? ' active'
                            : '')
                        }
                        onClick={() =>
                          this.onCheckAndUpdatePaymentMethod(
                            paymentMethodCode.installment
                          )
                        }>
                        {paymentMethodString[paymentMethodCode.installment]}
                      </li>
                      <li
                        key={1}
                        className={
                          'payment-btn' +
                          (paymentMethodCode.card === this.state.paymentMethod
                            ? ' active'
                            : '')
                        }
                        onClick={() =>
                          this.onCheckAndUpdatePaymentMethod(
                            paymentMethodCode.card
                          )
                        }>
                        {paymentMethodString[paymentMethodCode.card]}
                      </li>
                      <li
                        key={2}
                        className={
                          'payment-btn' +
                          (paymentMethodCode.cash === this.state.paymentMethod
                            ? ' active'
                            : '')
                        }
                        onClick={() =>
                          this.onCheckAndUpdatePaymentMethod(
                            paymentMethodCode.cash
                          )
                        }>
                        {paymentMethodString[paymentMethodCode.cash]}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div>
                <div className="detail-btn-box">
                  <div
                    className="detail-btn-box-2"
                    style={{ display: 'inline-block' }}>
                    <Button
                      className="body-element-block8-title"
                      type="primary"
                      htmlType="submit">
                      접수
                    </Button>
                  </div>

                  <div
                    className="detail-btn-box-1"
                    style={{ display: 'inline-block' }}>
                    <Button
                      style={{ marginTop: 0, color: skinType === "GOGOIT" ? '#1ECAD3' : '' }}
                      type="primary"
                      className="detail-modal-btn"
                      onClick={() => this.onClose()}>
                      취소
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { loginReducer, posReducer } = state;
  return { loginReducer, posReducer };
};
const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);
export default withAlert()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(UpdateReregistModal))
);
